"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheLongevityFrontier() {
  const {
    ref: headlineRef,
    isVisible: isHeadlineVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: isCtaVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235160" id="four-decades-of-structural-integrity" className="dark bg-background text-foreground relative min-h-screen flex flex-col overflow-hidden selection:bg-ring selection:text-primary-foreground">
      <div className="flex-grow grid grid-cols-1 lg:grid-cols-12">
        {}
        <div className="col-span-1 lg:col-span-7 flex flex-col justify-center px-6 sm:px-12 lg:px-20 xl:px-32 py-32 lg:py-0 z-10 relative">
          <div className="max-w-3xl">
            <h1 ref={headlineRef} className={`font-default text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.05] font-extrabold tracking-tighter transition-all duration-1000 ease-out ${isHeadlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              40 Years of <br className="hidden md:block" />
              <span className="text-ring">Structural</span> Excellence.
            </h1>
            
            <p ref={textRef} className={`font-mono text-xl md:text-2xl text-muted-foreground mt-8 max-w-2xl leading-relaxed font-medium transition-all duration-1000 delay-200 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              Multi-state licensed engineering in CA and UT. Expert structural evaluations and foundation solutions for over 300 properties.
            </p>

            <div ref={ctaRef} className={`mt-12 transition-all duration-1000 delay-400 ease-out ${isCtaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <Button variant="outline" size="lg" className="rounded-none border-ring/50 hover:bg-ring hover:text-primary-foreground tracking-[0.15em] uppercase text-xs h-14 px-10 transition-all duration-500" asChild>
                <Link to="/ConsultationPage">Request Consultation</Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="col-span-1 lg:col-span-5 relative h-[60vh] lg:h-auto overflow-hidden bg-muted">
          {}
          <div className="absolute inset-0 bg-primary/40 mix-blend-multiply z-10 pointer-events-none"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent lg:bg-gradient-to-l lg:from-transparent lg:to-background z-10 pointer-events-none"></div>
          
          {}
          <div className="absolute top-12 right-12 z-20 bg-ring text-primary-foreground px-6 py-3 font-mono text-sm font-bold tracking-widest shadow-xl">
            LICENSED IN 2 STATES
          </div>

          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658340/img/tall_complex_construction_project.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658340/img/tall_complex_construction_project.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658340/img/tall_complex_construction_project.png-wvc-sizes" alt="Tall complex construction project" loading="lazy" className="absolute inset-0 w-full h-full object-cover object-center filter grayscale contrast-125 brightness-90 scale-105 animate-[pulse_10s_ease-in-out_infinite_alternate]" style={{
          animationDuration: '20s'
        }} />
          
          {}
          <div className="absolute inset-0 opacity-10 pointer-events-none z-15" style={{
          backgroundImage: 'radial-gradient(circle, #ffffff 1px, transparent 1px)',
          backgroundSize: '30px 30px'
        }}>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4 z-20 pointer-events-none">
        <span className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground font-mono">
          Engineering Precision
        </span>
        <div className="w-[1px] h-16 bg-ring/30 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1/3 bg-ring animate-pulse"></div>
        </div>
      </div>
    </section>;
}